import { useCallback, useEffect, useRef } from "react";

/**
 * Returns a getter for an AbortSignal that is aborted when the component unmounts.
 * Pass it to the axios helpers: axiosGet(url, params, { signal: getSignal() }).
 */
export default function useAbortSignal() {
  const controllerRef = useRef(null);

  const getSignal = useCallback(() => {
    if (!controllerRef.current || controllerRef.current.signal.aborted) {
      controllerRef.current = new AbortController();
    }
    return controllerRef.current.signal;
  }, []);

  useEffect(
    () => () => {
      if (controllerRef.current) controllerRef.current.abort();
    },
    [],
  );

  return getSignal;
}
